import React, { Component } from 'react';
import DesktopTimesGridControls from './views/DesktopTimesGridControls';
import MobileTimesGridControls from './views/MobileTimesGridControls';
import TimesGridAppStarter from './app/TimesGridAppStarter';

/**
 * TimesGridControls only renders the controls portion of the times grid. To render
 * the content portion of the times grid, use TimesGridContent.
 *
 * Use this method of rendering the times grid only if you want the controls to manage
 * multiple times grid content (for multiple doctor location ids). Otherwise,
 * use the TimesGrid Component.
 */
@TimesGridAppStarter
export default class Controls extends Component {
    render() {
        if (this.props.isMobile) {
            return (
                <MobileTimesGridControls {...this.props} />
            );
        }

        return (
            <DesktopTimesGridControls {...this.props} />
        );
    }
}
